import React, { Component } from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import { Link } from 'react-router-dom';

import { StoreProvider } from '../../components';

import { default as CategoryCell } from './CategoryCell';

export class CategoryListView extends Component {
  render() {
    let categories = this.props.lists.categories.edges.map((e) => e.node);

    return (
      <div className="categories">
        <div className="header">
          <h2>
            Categories <span className="amount">({categories.length})</span>
          </h2>
          <div className="actions">
            <Link to="/categories/new" className="button">
              New Category
            </Link>
          </div>
        </div>
        <table className="tables">
          <thead>
            <tr>
              <th>Category Name</th>
            </tr>
          </thead>
          <tbody>
            {categories.map((category) => (
              <CategoryCell
                key={category.id}
                category={category}
                lists={this.props.lists}
              />
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

const Container = createFragmentContainer(CategoryListView, {
  lists: graphql`
    fragment CategoryList_lists on Lists {
      ...CategoryCell_lists
      categories(first: 1000) @connection(key: "CategoryList_categories") {
        edges {
          node {
            id
            ...CategoryCell_category
          }
        }
      }
    }
  `,
});

export default class CategoryList extends Component {
  render() {
    return (
      <StoreProvider
        modern
        container={Container}
        query={graphql`
          query CategoryListQuery {
            lists {
              ...CategoryList_lists
            }
          }
        `}
      />
    );
  }
}
